export default __webpack_public_path__ + "static/media/Dorcas Elekima.0b6a3da0.jpg";